import { useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { deleteAudience } from '../../../../lib/redux/actions.jsx';
import DeleteComponent from '../../../../shared/SettingsModal/DeleteComponent.jsx';
import { Modal } from '../Modals/Modal.jsx';

export const DeleteModal = ({ open, setOpen, item, setItem }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { t } = useTranslation('edit');
  const deletePhrases = [t('audiencesList.deleteTopicPhrase1')];

  const onClose = () => {
    setItem(null);
    setOpen(false);
  };

  const onConfirm = () => {
    dispatch(deleteAudience(item)).then(() => {
      queryClient.invalidateQueries(['boardSettings']);
      queryClient.invalidateQueries(['plans']);
      setOpen(false).then(() => setItem(null));
    });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <DeleteComponent
        phrases={deletePhrases}
        onConfirm={onConfirm}
        onCancel={onClose}
      />
    </Modal>
  );
};
